/**
 * <cart-recommendations>
 * Recomendaciones dentro del cajón del carrito ("Completa tu lunch").
 *
 * - Pide productos relacionados con el último artículo agregado usando la API
 *   nativa de Shopify (/recommendations/products.json) y descarta los que ya
 *   están en el carrito o no tienen existencias.
 * - El botón "Agregar" hace POST a /cart/add.js y dispara `cart:update`, el
 *   mismo evento que usan los botones de la portada: el tema vuelve a renderizar
 *   el cajón, y este componente se actualiza solo con los nuevos atributos.
 *
 * Atributos (los pone snippets/cart-recommendations.liquid):
 *   data-product-id  producto base para las recomendaciones
 *   data-exclude     ids de producto ya en el carrito, separados por coma
 *   data-limit       cuántas tarjetas mostrar (por defecto 4)
 *   data-add-label   texto del botón
 */
(function () {
  if (customElements.get('cart-recommendations')) return;

  var money = function (cents) {
    return '$ ' + new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
  };

  var ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ESC[c]; });
  };

  var imgUrl = function (url, w) {
    if (!url) return '';
    try {
      var u = new URL(url, location.origin);
      u.searchParams.set('width', String(w));
      return u.toString();
    } catch (e) {
      return url;
    }
  };

  class CartRecommendations extends HTMLElement {
    static get observedAttributes() {
      return ['data-product-id', 'data-exclude'];
    }

    constructor() {
      super();
      this.addEventListener('click', this.onClick.bind(this));
    }

    connectedCallback() {
      this.load();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue !== null && oldValue !== newValue && this.isConnected) this.load();
    }

    getList() {
      return this.querySelector('[data-recs-list]');
    }

    async load() {
      var productId = this.dataset.productId;
      var list = this.getList();
      if (!productId || !list) return;

      var exclude = {};
      (this.dataset.exclude || '').split(',').forEach(function (id) { if (id) exclude[id] = true; });
      var limit = parseInt(this.dataset.limit || '4', 10) || 4;
      var key = productId + '|' + Object.keys(exclude).sort().join(',');
      if (this.dataset.loadedKey === key) return;
      this.dataset.loadedKey = key;

      try {
        var res = await fetch('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=' + (limit + 6) + '&intent=related', {
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) throw new Error('recs ' + res.status);
        var data = await res.json();
        var products = (data.products || [])
          .filter(function (p) { return p.available && !exclude[String(p.id)]; })
          .slice(0, limit);

        if (!products.length) {
          this.hidden = true;
          return;
        }

        list.innerHTML = products.map(this.card.bind(this)).join('');
        this.hidden = false;
      } catch (e) {
        this.hidden = true;
      }
    }

    card(p) {
      var variants = p.variants || [];
      var variant = variants.filter(function (v) { return v.available; })[0] || variants[0];
      var image = p.featured_image || (p.images && p.images[0]) || '';
      var onSale = p.compare_at_price && p.compare_at_price > p.price;
      var label = esc(this.dataset.addLabel || 'Agregar');
      var img = image
        ? '<img src="' + esc(imgUrl(image, 160)) + '" srcset="' + esc(imgUrl(image, 160)) + ' 1x, ' + esc(imgUrl(image, 320)) + ' 2x" alt="" width="80" height="80" loading="lazy" decoding="async">'
        : '';
      var compare = onSale ? ' <s class="cart-recs__compare">' + money(p.compare_at_price) + '</s>' : '';
      return (
        '<li class="cart-recs__item">' +
          '<a class="cart-recs__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
          '<div class="cart-recs__info">' +
            '<a class="cart-recs__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<span class="cart-recs__price">' + money(p.price) + compare + '</span>' +
          '</div>' +
          '<button type="button" class="cart-recs__add" data-variant-id="' + (variant ? variant.id : '') + '"' + (variant ? '' : ' disabled') + ' aria-label="' + label + ': ' + esc(p.title) + '">' +
            '<span class="cart-recs__add-text">+ ' + label + '</span>' +
          '</button>' +
        '</li>'
      );
    }

    async onClick(event) {
      var btn = event.target.closest('.cart-recs__add');
      if (!btn || btn.disabled) return;
      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;
      var text = btn.querySelector('.cart-recs__add-text');
      var original = text ? text.textContent : '';
      if (text) text.textContent = '…';

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
        });
        if (!res.ok) throw new Error('add ' + res.status);
        if (text) text.textContent = '✓';
        // Mismo evento que los botones de la portada: el tema vuelve a pintar el cajón.
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { data: { sections: {}, itemCount: 1, source: 'cart-recommendations' } },
          })
        );
      } catch (e) {
        if (text) text.textContent = original;
        btn.disabled = false;
      }
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);
})();
